import { QueryClient } from '@tanstack/react-query';
export const storyQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    },
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mockStoryQueryData({ query, queryKey, queryData, }) {
    storyQueryClient.setQueryData(queryKey ?? query.keys, {
        body: {
            data: queryData,
        },
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3Rvcnlib29rLXV0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL3N0b3J5Ym9vay11dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sdUJBQXVCLENBQUM7QUFJcEQsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUcsSUFBSSxXQUFXLENBQUM7SUFDOUMsY0FBYyxFQUFFO1FBQ2QsT0FBTyxFQUFFO1lBQ1AsS0FBSyxFQUFFLEtBQUs7WUFDWixjQUFjLEVBQUUsS0FBSztZQUNyQixvQkFBb0IsRUFBRSxLQUFLO1lBQzNCLGtCQUFrQixFQUFFLEtBQUs7U0FDMUI7S0FDRjtDQUNGLENBQUMsQ0FBQztBQUVILDhEQUE4RDtBQUM5RCxNQUFNLFVBQVUsa0JBQWtCLENBQTJDLEVBQzNFLEtBQUssRUFDTCxRQUFRLEVBQ1IsU0FBUyxHQU1WO0lBQ0MsZ0JBQWdCLENBQUMsWUFBWSxDQUFDLFFBQVEsSUFBSSxLQUFLLENBQUMsSUFBSSxFQUFFO1FBQ3BELElBQUksRUFBRTtZQUNKLElBQUksRUFBRSxTQUFTO1NBQ2hCO0tBQ0YsQ0FBQyxDQUFDO0FBQ0wsQ0FBQyJ9